<template>
  <div style="background-color : #fff7f4">
    <div class="p-4 max-w-6xl mx-auto flex flex-col items-start justify-start min-h-screen">
      <div class="flex items-center justify-between w-full mb-4">
        <div>
          <img
            src="/img/logo-yuk-belajar-optimized.png"
            class="h-16 sm:hidden">
          <img
            src="/img/logo-dan-nama-yuk-belajar.png"
            class="hidden sm:block">
        </div>
      </div>
      <div class="bg-white shadow-md rounded w-full flex-grow flex flex-col items-start justify-start md:p-4 py-4">
        <div class="flex-grow w-full max-w-3xl mx-auto px-4 leading-tight font-serif text-gray-900">
          <div
            v-for="section in $store.state.questionBySection"
            :key="section.id"
            class="mb-10">
            <div class="font-bold text-2xl mb-5 p-3 text-center">
              Review {{ module_name }}
            </div>
            <div class="font-bold text-xl mb-5 p-3 bg-blue-600 text-white text-center">
              {{ section.name }}
            </div>
            <div
              v-for="(question, i) in section.questions"
              :key="question.id.toString() + i.toString()"
              class="mt-3 mb-8 md:text-lg ">
              <div class="flex items-center justify-start">
                <a
                  target="_blank"
                  :href="'/office/resources/questions/'+question.id+'/edit'"
                  class="w-5 h-5 text-blue-600 mr-2"
                  title="Edit">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-current"
                    viewBox="0 0 512 512"><path d="M469.54,120.52h0a16,16,0,0,0-25.54-4L382.56,178a16.12,16.12,0,0,1-22.63,0L333.37,151.4a16,16,0,0,1,0-22.63l61.18-61.19a16,16,0,0,0-4.78-25.92h0C343.56,21,285.88,31.78,249.51,67.88c-30.9,30.68-40.11,78.62-25.25,131.53a15.89,15.89,0,0,1-4.49,16L53.29,367.46a64.17,64.17,0,1,0,90.6,90.64L297.57,291.25a15.9,15.9,0,0,1,15.77-4.57,179.3,179.3,0,0,0,46.22,6.37c33.4,0,62.71-10.81,83.85-31.64C482.56,222.84,488.53,157.42,469.54,120.52ZM99.48,447.15a32,32,0,1,1,28.34-28.35A32,32,0,0,1,99.48,447.15Z" /></svg>
                </a>
                <div class="mb-1 font-semibold w-full">
                  Soal Nomor {{ i+1 }} | Question ID {{ question.id }}
                </div>
              </div>
              <div
                v-if="question.reference != null && ((section.questions[i-1] == undefined) || (section.questions[i-1] != undefined && ((section.questions[i-1].reference == null) || (section.questions[i-1].reference != null && section.questions[i-1].reference.id != question.reference.id))))"
                class="flex flex-col items-start justify-start">
                <div class="flex items-center justify-start">
                  <a
                    target="_blank"
                    :href="'/office/resources/references/'+question.reference.id+'/edit'"
                    class="w-5 h-5 text-blue-600 mr-2"
                    title="Edit">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="fill-current"
                      viewBox="0 0 512 512"><path d="M469.54,120.52h0a16,16,0,0,0-25.54-4L382.56,178a16.12,16.12,0,0,1-22.63,0L333.37,151.4a16,16,0,0,1,0-22.63l61.18-61.19a16,16,0,0,0-4.78-25.92h0C343.56,21,285.88,31.78,249.51,67.88c-30.9,30.68-40.11,78.62-25.25,131.53a15.89,15.89,0,0,1-4.49,16L53.29,367.46a64.17,64.17,0,1,0,90.6,90.64L297.57,291.25a15.9,15.9,0,0,1,15.77-4.57,179.3,179.3,0,0,0,46.22,6.37c33.4,0,62.71-10.81,83.85-31.64C482.56,222.84,488.53,157.42,469.54,120.52ZM99.48,447.15a32,32,0,1,1,28.34-28.35A32,32,0,0,1,99.48,447.15Z" /></svg>
                  </a>
                  <div class="mb-1 font-semibold w-full">
                    Reference ID {{ question.reference.id }}
                  </div>
                </div>
                <div
                  v-if="question.reference.content != null"
                  class="reference"
                  v-html="removeLink(question.reference.content)" />
                <div
                  v-else
                  class="reference" />
              </div>
              <div
                v-if="question.reference != null && (section.questions[i-1] != undefined && section.questions[i-1].reference != null && section.questions[i-1].reference.id == question.reference.id)"
                class="flex flex-col items-start justify-start">
                <div class="flex items-center justify-start">
                  <a
                    target="_blank"
                    :href="'/office/resources/references/'+question.reference.id+'/edit'"
                    class="w-5 h-5 text-blue-600 mr-2"
                    title="Edit">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="fill-current"
                      viewBox="0 0 512 512"><path d="M469.54,120.52h0a16,16,0,0,0-25.54-4L382.56,178a16.12,16.12,0,0,1-22.63,0L333.37,151.4a16,16,0,0,1,0-22.63l61.18-61.19a16,16,0,0,0-4.78-25.92h0C343.56,21,285.88,31.78,249.51,67.88c-30.9,30.68-40.11,78.62-25.25,131.53a15.89,15.89,0,0,1-4.49,16L53.29,367.46a64.17,64.17,0,1,0,90.6,90.64L297.57,291.25a15.9,15.9,0,0,1,15.77-4.57,179.3,179.3,0,0,0,46.22,6.37c33.4,0,62.71-10.81,83.85-31.64C482.56,222.84,488.53,157.42,469.54,120.52ZM99.48,447.15a32,32,0,1,1,28.34-28.35A32,32,0,0,1,99.48,447.15Z" /></svg>
                  </a>
                  <div class="mb-1 font-semibold w-full">
                    Reference ID {{ question.reference.id }} <span class="text-sm italic">(sama dengan sebelumnya)</span>
                  </div>
                </div>
                <div class="reference" />
              </div>
              <div
                class="question mb-2"
                v-html="removeLink(question.content)" />
              <div class="answer" v-if="section.type == 'multiple'">
                <div
                  v-for="(answer, j) in question.answers"
                  :key="answer.id.toString() + j.toString()">
                  <div
                    class="mb-2 flex items-center justify-start"
                    :class="{'text-green-600 font-semibold': answer.is_solution}">
                    <div class="flex items-center justify-start">
                      <a
                        target="_blank"
                        :href="'/office/resources/answers/'+answer.id+'/edit'"
                        class="w-5 h-5 text-blue-600 mr-2"
                        title="Edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="fill-current"
                          viewBox="0 0 512 512"><path d="M469.54,120.52h0a16,16,0,0,0-25.54-4L382.56,178a16.12,16.12,0,0,1-22.63,0L333.37,151.4a16,16,0,0,1,0-22.63l61.18-61.19a16,16,0,0,0-4.78-25.92h0C343.56,21,285.88,31.78,249.51,67.88c-30.9,30.68-40.11,78.62-25.25,131.53a15.89,15.89,0,0,1-4.49,16L53.29,367.46a64.17,64.17,0,1,0,90.6,90.64L297.57,291.25a15.9,15.9,0,0,1,15.77-4.57,179.3,179.3,0,0,0,46.22,6.37c33.4,0,62.71-10.81,83.85-31.64C482.56,222.84,488.53,157.42,469.54,120.52ZM99.48,447.15a32,32,0,1,1,28.34-28.35A32,32,0,0,1,99.48,447.15Z" /></svg>
                      </a>
                      <div class="w-5 mr-2">
                        {{ answerChars[j] }}
                      </div>
                    </div>
                    <div
                      class="w-full"
                      v-html="removeLink(answer.content)" />
                  </div>
                </div>
              </div>
              <div class="mb-1 font-semibold italic">
                Pembahasan
              </div>
              <div
                v-if="question.solution != null"
                class="mb-3 solution"
                v-html="removeLink(question.solution)" />
              <div
                v-else
                class="italic">
                -
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['module_name'],
  data: function() {
    return {
      answerChars: ['A.', 'B.', 'C.', 'D.', 'E.'],
    };
  },
  computed: {},
  watch: {},
  async mounted() {},
  created() {},
  methods: {
    removeLink(htmlString) {
      return htmlString.replace(/<a\b[^>]*>/g,'').replace(/<\/a>/g, '');
    },
  }
}
</script>
<style>
    .attachment__caption {
        display: none;
    }
    .question figure.attachment, .reference figure.attachment, .solution figure.attachment {
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }
    .question div, .solution div, .reference div {
        margin-bottom: 0.75rem;
    }
    .question div br, .solution div br, .reference div br {
        margin-bottom: 0.75rem;
        display: block;
        content: ' ';
    }
</style>
